// extracted by mini-css-extract-plugin
export default {"TrainingCategoryBox":"trainingCategoryBox_TrainingCategoryBox__vl4Vt"};